import { deleteAPI, getAPI, patchAPI, postAPI, putAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

const buildBannerQueryString = ({ type, active, link }) => {
  const params = new URLSearchParams();
  params.set('type', type || 'MOBILE');
  params.set(
    'active',
    String(typeof active === 'boolean' ? active : true)
  );
  if (link) {
    params.set('link', link);
  }
  return params.toString();
};

const buildBannerFormData = (payload) => {
  if (payload instanceof FormData) {
    return payload;
  }
  if (payload?.file) {
    const formData = new FormData();
    formData.append('file', payload.file);
    return formData;
  }
  return null;
};

export const getAllAdminBanner = (payload, userId, callBack, errorCallback) => {
  return (dispatch) => {
    const queryParams = {
      page: payload?.page ?? 0,
      size: payload?.size ?? payload?.perPage ?? 20,
      type: payload?.type || undefined,
      active:
        typeof payload?.active === 'boolean' ? payload.active : undefined,
    };

    getAPI(
      endpoints.GET_ALL_BANNER,
      queryParams,
      (response) => {
        callBack(response);
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const addBanner = (userId, payload, callBack, errorCallback) => {
  return (dispatch) => {
    const type = payload?.type || 'MOBILE';
    const active =
      typeof payload?.active === 'boolean' ? payload.active : true;
    const link = payload?.link || '';
    const requestPayload = buildBannerFormData(payload);

    if (!requestPayload) {
      errorCallback({ message: 'Banner file is required' });
      return;
    }

    const query = buildBannerQueryString({ type, active, link });

    postAPI(
      `${endpoints.ADD_BANNER}?${query}`,
      requestPayload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};

export const updateBanner = (
  bannerId,
  payload,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    const type = payload?.type || 'MOBILE';
    const active =
      typeof payload?.active === 'boolean' ? payload.active : true;
    const link = payload?.link || payload?.redirectUrl || '';
    const requestPayload = buildBannerFormData(payload);

    if (!requestPayload) {
      errorCallback({ message: 'Banner file is required' });
      return;
    }

    const query = buildBannerQueryString({ type, active, link });

    patchAPI(
      `${endpoints.EDIT_BANNER}/${bannerId}?${query}`,
      requestPayload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};

export const deleteBanner = (
  bannerId,
  payload,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    deleteAPI(
      `${endpoints.EDIT_BANNER}/${bannerId}`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};

export const updateBannerDisplayOrder = (
  bannerId,
  displayOrder,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    const orderNum = Number(displayOrder);
    const primaryUrl = endpoints.BANNER_ORDER.replace(':id', bannerId);
    const urlWithQuery = `${primaryUrl}?displayOrder=${orderNum}&order=${orderNum}`;
    const payload = { displayOrder: orderNum, order: orderNum };

    patchAPI(
      urlWithQuery,
      payload,
      (response) => {
        if (typeof callBack === 'function') callBack(response);
      },
      (error) => {
        if (typeof errorCallback === 'function') errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};

export const batchReorderBanners = (
  reorderList,
  callBack,
  errorCallback
) => {
  return (dispatch) => {
    const payload = Array.isArray(reorderList) ? reorderList : [];
    putAPI(
      endpoints.BANNER_REORDER,
      payload,
      (response) => {
        if (typeof callBack === 'function') callBack(response);
      },
      (error) => {
        if (typeof errorCallback === 'function') errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};
